import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { auth, db } from "../firebase/config";
import { useAuthState } from "react-firebase-hooks/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const EditListing = () => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const { listingId } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchListing = async () => {
      try {
        if (!user) return;

        const docRef = doc(db, "listings", listingId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setListing(docSnap.data());
        } else {
          setError("İlan bulunamadı");
        }
      } catch (err) {
        console.error("Error fetching listing:", err);
        setError("İlan yüklenirken bir hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    fetchListing();
  }, [user, listingId]);

  const handleChange = (e) => {
    setListing({
      ...listing,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const docRef = doc(db, "listings", listingId);
      await updateDoc(docRef, listing);
      navigate("/my-listings");
    } catch (err) {
      console.error("Error updating listing:", err);
      setError("İlan güncellenirken bir hata oluştu");
    }
  };

  if (loading) {
    return (
      <div className='min-h-screen bg-[#F8F9FA] py-8'>
        <div className='max-w-6xl mx-auto px-4'>
          <div className='flex justify-center items-center h-64'>
            <div className='animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500'></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='min-h-screen bg-[#F8F9FA] py-8'>
        <div className='max-w-6xl mx-auto px-4'>
          <div className='text-center text-red-600 font-architects-daughter'>
            {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen bg-[#F8F9FA] py-8'>
      <div className='max-w-6xl mx-auto px-4'>
        <h1 className='text-3xl font-bold font-architects-daughter text-[#212529] mb-8'>
          Edit Listing
        </h1>
        <form onSubmit={handleSubmit} className='space-y-6'>
          <div>
            <label className='block font-architects-daughter mb-1'>Title</label>
            <input
              type='text'
              name='title'
              value={listing.title || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required
            />
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              Job Type
            </label>
            <select
              name='jobType'
              value={listing.jobType || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required>
              <option value='full-time'>Full Time</option>
              <option value='part-time'>Part Time</option>
              <option value='seasonal'>Seasonal</option>
              <option value='weekends'>Weekends Only</option>
            </select>
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              Salary
            </label>
            <input
              type='number'
              name='salary'
              value={listing.salary || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required
            />
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              English Level
            </label>
            <select
              name='englishLevel'
              value={listing.englishLevel || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required>
              <option value='basic'>Basic</option>
              <option value='intermediate'>Intermediate</option>
              <option value='advanced'>Advanced</option>
            </select>
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              Description
            </label>
            <textarea
              name='description'
              value={listing.description || ""}
              onChange={handleChange}
              rows={4}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required
            />
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              Contact Email
            </label>
            <input
              type='email'
              name='contactEmail'
              value={listing.contactEmail || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required
            />
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              Contact Phone
            </label>
            <input
              type='tel'
              name='contactPhone'
              value={listing.contactPhone || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required
            />
          </div>
          <div>
            <label className='block font-architects-daughter mb-1'>
              Address
            </label>
            <input
              type='text'
              name='location'
              value={listing.location || ""}
              onChange={handleChange}
              className='w-full p-2 border rounded focus:outline-none focus:border-blue-500'
              required
            />
          </div>
          <div>
            <button
              type='submit'
              className='w-full py-3 px-4 border border-transparent rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-medium text-lg'>
              Update Listing
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditListing;
